import { render, staticRenderFns } from "./DialogTrip.vue?vue&type=template&id=521365d1&scoped=true"
import script from "./DialogTrip.vue?vue&type=script&lang=js"
export * from "./DialogTrip.vue?vue&type=script&lang=js"
import style0 from "./DialogTrip.vue?vue&type=style&index=0&id=521365d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521365d1",
  null
  
)

export default component.exports